import React, { useState } from 'react';
import ForgotPassword from './ForgotPassword';
import VerifyResetOTP from './VerifyResetOTP';
import NewPassword from './NewPassword';

export type PasswordResetStep = 'request' | 'verify' | 'reset' | 'success';

const PasswordReset: React.FC = () => {
  const [step, setStep] = useState<PasswordResetStep>('request');
  const [email, setEmail] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleEmailSubmit = (submittedEmail: string, successMessage: string) => {
    setEmail(submittedEmail);
    setMessage(successMessage);
    setError(null);
    setStep('verify');
  };

  const handleOtpVerify = (verifiedOtp: string, successMessage: string) => {
    setOtpCode(verifiedOtp);
    setMessage(successMessage);
    setError(null);
    setStep('reset');
  };

  const handlePasswordReset = (successMessage: string) => {
    setMessage(successMessage);
    setError(null);
    setStep('success');
  };

  const handleBackToRequest = () => {
    setStep('request');
    setError(null);
    setMessage(null);
    setEmail('');
    setOtpCode('');
  };

  const handleBackToVerify = () => {
    setStep('verify');
    setError(null);
    setOtpCode('');
  };

  const renderStep = () => {
    switch (step) {
      case 'request':
        return (
          <ForgotPassword onEmailSubmit={handleEmailSubmit} error={error} setError={setError} />
        );
      case 'verify':
        return (
          <VerifyResetOTP
            email={email}
            onOtpVerify={handleOtpVerify}
            onBackToRequest={handleBackToRequest}
            error={error}
            setError={setError}
            message={message}
          />
        );
      case 'reset':
        return (
          <NewPassword
            email={email}
            otpCode={otpCode}
            onPasswordReset={handlePasswordReset}
            onBackToVerify={handleBackToVerify}
            onBackToRequest={handleBackToRequest}
            error={error}
            setError={setError}
            message={message}
          />
        );
      case 'success':
        return (
          <div className="w-full max-w-md mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-green-100 rounded-full">
                  <svg
                    className="h-8 w-8 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-4">Password Reset Successful!</h1>
              <p className="text-gray-600 mb-6">{message}</p>
              <a
                href="/auth"
                className="inline-flex items-center justify-center w-full px-4 py-2 bg-[#07E5D1] text-white font-medium rounded-lg hover:bg-[#06D4C2] transition-colors"
              >
                Continue to Login
              </a>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#FEFEFE] flex items-center justify-center p-4">
      {renderStep()}
    </div>
  );
};

export default PasswordReset;
